import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from 'auth/services/auth.service';
import 'rxjs/add/operator/do';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private router: Router, private http: Http, private authService: AuthService) { }

  public canActivate(): Observable<boolean> {
    return this.authService.getLoggedIn()
      .do((isLoggedIn) => {
        if (!isLoggedIn) {
          this.router.navigateByUrl('/login');
        }
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/guards/login.guard.ts